import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const SchoolPlayerProfileSecondaryButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)] sm:w-auto",
})``;

export const SchoolPlayerProfileDangerButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-rose-600 px-4 py-3 text-sm font-medium text-white transition hover:bg-rose-700 sm:w-auto",
})``;

export const SchoolPlayerProfileTabStack = styled.div.attrs({
  className: "grid gap-6",
})``;

export const SchoolPlayerProfileSection = styled.div.attrs({ className: "mt-8" })``;

export const SchoolPlayerProfileTopGrid = styled.div.attrs({
  className: "grid gap-6 xl:grid-cols-[minmax(0,1.2fr)_minmax(18rem,0.8fr)] xl:items-stretch",
})``;

export const SchoolPlayerProfileContentStack = styled.div.attrs({ className: "space-y-5" })``;

export const SchoolPlayerProfileHeroPanel = styled.div.attrs({
  className: "flex flex-col gap-5 sm:flex-row sm:items-stretch",
})``;

export const SchoolPlayerProfileHeroImage = styled(FallbackImage).attrs({
  className:
    "mx-auto h-52 w-40 shrink-0 rounded-[22px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] shadow-[0_12px_20px_rgba(0,0,0,0.18)] sm:mx-0 sm:h-auto sm:min-h-[14rem] sm:w-40 md:w-44 lg:w-48",
})``;

export const SchoolPlayerProfileHeroBody = styled.div.attrs({
  className: "flex min-w-0 flex-1 flex-col justify-between gap-5",
})``;

export const SchoolPlayerProfileHeroTextGroup = styled.div.attrs({
  className: "min-w-0",
})``;

export const SchoolPlayerProfileHeroEyebrow = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.22em] text-[var(--brand-highlight)]",
})``;

export const SchoolPlayerProfileHeroTitle = styled.h3.attrs({
  className: "mt-2 text-xl font-semibold text-[var(--brand-ink)] sm:text-2xl",
})``;

export const SchoolPlayerProfileHeroMeta = styled.p.attrs({
  className: "mt-1 text-sm leading-6 text-[var(--brand-muted)]",
})``;

export const SchoolPlayerProfileBadgeRow = styled.div.attrs({
  className: "mt-3 flex flex-wrap items-center gap-2",
})``;

export const SchoolPlayerProfileBioText = styled.p.attrs({
  className: "mt-4 text-sm leading-7 text-[var(--brand-ink)]",
})``;

export const SchoolPlayerProfileMetadataGrid = styled.div.attrs({
  className: "grid gap-3 sm:grid-cols-2 xl:grid-cols-3",
})``;

export const SchoolPlayerProfileMetadataTile = styled.div.attrs({
  className: "brand-panel-muted rounded-[18px] px-4 py-3.5",
})``;

export const SchoolPlayerProfileEyebrowText = styled.p.attrs({
  className: "text-[11px] uppercase tracking-[0.18em] text-[var(--brand-muted)]",
})``;

export const SchoolPlayerProfileTitleText = styled.p.attrs({
  className: "mt-1.5 text-base font-medium leading-snug text-[var(--brand-ink)]",
})``;

export const SchoolPlayerProfileGuardianCard = styled.div.attrs({
  className: "flex min-h-0 flex-1 flex-col gap-4",
})``;

export const SchoolPlayerProfileGuardianHeader = styled.div.attrs({
  className: "flex flex-wrap items-center justify-between gap-3",
})``;

export const SchoolPlayerProfileGuardianName = styled.p.attrs({
  className: "text-lg font-medium text-[var(--brand-ink)]",
})``;

export const SchoolPlayerProfileContactList = styled.div.attrs({
  className: "grid flex-1 content-start gap-3",
})``;

export const SchoolPlayerProfileContactRow = styled.div.attrs({
  className: "brand-panel-muted rounded-[18px] px-4 py-3.5",
})``;

export const SchoolPlayerProfileContactLabel = styled.p.attrs({
  className: "text-[11px] uppercase tracking-[0.18em] text-[var(--brand-muted)]",
})``;

export const SchoolPlayerProfileContactValue = styled.p.attrs({
  className: "mt-1.5 break-words text-sm font-medium leading-snug text-[var(--brand-ink)]",
})``;

export const SchoolPlayerProfileFootprintStack = styled.div.attrs({
  className: "space-y-5",
})``;

export const SchoolPlayerProfileFootprintBlock = styled.div.attrs({
  className: "space-y-3",
})``;

export const SchoolPlayerProfileFootprintHeading = styled.p.attrs({
  className: "text-[11px] uppercase tracking-[0.18em] text-[var(--brand-muted)]",
})``;

export const SchoolPlayerProfileTeamButton = styled.button.attrs({
  className:
    "flex w-full items-center gap-3 rounded-[18px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] px-3 py-2.5 text-left transition hover:border-[var(--brand-highlight)]/50 hover:bg-[rgba(240,191,86,0.06)]",
})``;

export const SchoolPlayerProfileTeamList = styled.div.attrs({
  className: "grid gap-2 sm:grid-cols-2",
})``;

export const SchoolPlayerProfileInfoRow = styled.div.attrs({
  className: "flex min-w-0 items-center gap-3",
})``;

export const SchoolPlayerProfileThumbnailImage = styled(FallbackImage).attrs({
  className: "h-10 w-10 shrink-0 rounded-2xl",
})``;

export const SchoolPlayerProfileTextGroup = styled.div.attrs({ className: "min-w-0" })``;

export const SchoolPlayerProfileLabelText = styled.p.attrs({
  className: "truncate font-medium text-[var(--brand-ink)]",
})``;

export const SchoolPlayerProfileMetaTextSecondary = styled.p.attrs({
  className: "truncate text-xs text-[var(--brand-muted)]",
})``;

export const SchoolPlayerProfileEmptyCopy = styled.p.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const SchoolPlayerProfileChipRow = styled.div.attrs({
  className: "flex flex-wrap gap-2",
})``;

export const SchoolPlayerProfileStatusBadge = styled.span.attrs({
  className:
    "inline-flex items-center rounded-full border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-3 py-1.5 text-xs font-medium text-[var(--brand-ink)]",
})``;

export const SchoolPlayerProfilePerformancePrimaryGrid = styled.div.attrs({
  className: "grid gap-6 xl:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)] xl:items-start",
})``;

export const SchoolPlayerProfilePerformanceSecondaryGrid = styled.div.attrs({
  className: "grid gap-6 xl:grid-cols-2 xl:items-start",
})``;

export const SchoolPlayerProfilePerformanceList = styled.div.attrs({
  className: "space-y-3",
})``;

export const SchoolPlayerProfilePerformanceSnapshot = styled.div.attrs({
  className: "rounded-[1.25rem] border border-[var(--brand-border)] bg-[var(--brand-hero-surface)] p-4",
})``;

export const SchoolPlayerProfilePerformanceSeasonHeader = styled.div.attrs({
  className: "flex flex-wrap items-start justify-between gap-3",
})``;

export const SchoolPlayerProfilePerformanceSnapshotTitle = styled.p.attrs({
  className: "mt-1.5 text-lg font-semibold text-[var(--brand-ink)]",
})``;

export const SchoolPlayerProfilePerformanceSeasonMeta = styled.p.attrs({
  className: "mt-1 text-sm text-[var(--brand-muted)]",
})``;

export const SchoolPlayerProfilePerformanceMetricGrid = styled.div.attrs({
  className: "mt-4 grid gap-3 sm:grid-cols-2",
})``;

export const SchoolPlayerProfilePerformanceMetricTile = styled.div.attrs({
  className: "brand-panel-muted rounded-[18px] px-4 py-3.5",
})``;

export const SchoolPlayerProfilePerformanceMetricValue = styled.p.attrs({
  className: "mt-1.5 text-xl font-semibold text-[var(--brand-ink)]",
})``;

export const SchoolPlayerProfilePerformanceSeasonRow = styled.div.attrs({
  className:
    "flex items-center justify-between gap-3 rounded-[18px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] px-3.5 py-3",
})``;

export const SchoolPlayerProfilePerformanceSeasonTitle = styled.p.attrs({
  className: "truncate font-medium text-[var(--brand-ink)]",
})``;

export const SchoolPlayerProfilePerformancePositionRow = styled.div.attrs({
  className: "space-y-2 rounded-[18px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] px-3.5 py-3",
})``;

export const SchoolPlayerProfilePerformancePositionHeader = styled.div.attrs({
  className: "flex flex-wrap items-baseline justify-between gap-2",
})``;

export const SchoolPlayerProfilePerformancePositionName = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const SchoolPlayerProfilePerformancePositionMeta = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;

export const SchoolPlayerProfilePerformanceBarTrack = styled.div.attrs({
  className: "h-1.5 w-full overflow-hidden rounded-full bg-[rgba(255,255,255,0.08)]",
})``;

export const SchoolPlayerProfilePerformanceBarFill = styled.div.attrs({
  className: "h-full rounded-full bg-[var(--brand-highlight)]",
})``;

export const SchoolPlayerProfilePerformanceCareerRow = styled.div.attrs({
  className: "flex gap-3 rounded-[18px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] px-3.5 py-3",
})``;

export const SchoolPlayerProfilePerformanceCareerYear = styled.p.attrs({
  className:
    "w-12 shrink-0 font-anonymous text-xs uppercase tracking-[0.18em] text-[var(--brand-highlight)]",
})``;

export const SchoolPlayerProfilePerformanceCareerTeam = styled.p.attrs({
  className: "truncate font-medium text-[var(--brand-ink)]",
})``;

export const SchoolPlayerProfilePerformanceCareerMeta = styled.p.attrs({
  className: "mt-0.5 truncate text-xs text-[var(--brand-muted)]",
})``;

export const SchoolPlayerProfilePerformanceAchievementRow = styled.div.attrs({
  className: "rounded-[18px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] px-3.5 py-3",
})``;

export const SchoolPlayerProfilePerformanceAchievementTitle = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const SchoolPlayerProfilePerformanceAchievementMeta = styled.p.attrs({
  className: "mt-1 text-xs text-[var(--brand-muted)]",
})``;
